module.exports = __webpack_public_path__ + "static/media/5.11b2643e.png";